import useCurrentGroup from '../../../../hooks/useCurrentGroup';
import { useFlowsRouteParams } from '../../../../hooks/useFlowsRouteParams';
import {
  FlowQuestionRules,
  FlowsQuestionGroup,
} from '../../../../types/FlowsTypes';
import { InputConfig, InputConfigProps } from '../../../../types/ConfigTypes';
import { getInputConfig } from '../../../input/inputConfig';

const useInputGridConfig = (
  group?: FlowsQuestionGroup,
): InputConfigProps['gridConfig'] => {
  const { flowId } = useFlowsRouteParams();
  const currentGroup = group || useCurrentGroup();

  const getGridConfigForFlowId = (rules: FlowQuestionRules) => {
    const flowInputConfig = getInputConfig(flowId || '')?.[
      rules.input_type
    ] as InputConfig;

    if (flowId && flowInputConfig.flowOverride?.[flowId]) {
      return flowInputConfig.flowOverride[flowId].gridConfig;
    }
    return flowInputConfig.gridConfig;
  };

  // It's not possible to dynamically receive a list of possible props in a string[]
  // format. So this has to be hardcoded.
  const isExpandedGrid = currentGroup?.questions.some(
    ({ rules }) => getGridConfigForFlowId(rules).isExpandedGrid,
  );
  const isFullWidth = currentGroup?.questions.every(
    ({ rules }) => getGridConfigForFlowId(rules).isFullWidth,
  );

  const isFullScreen =
    currentGroup?.questions.some(
      ({ rules }) => getGridConfigForFlowId(rules).isFullScreen,
    ) && currentGroup?.questions.length < 2;
  const isContinueButtonHidden = currentGroup?.questions.some(
    ({ rules }) => getGridConfigForFlowId(rules).isContinueButtonHidden,
  );

  return {
    isExpandedGrid,
    isFullWidth,
    isFullScreen,
    isContinueButtonHidden,
  };
};

export default useInputGridConfig;
